import { render, staticRenderFns } from "./PuzzleGrid.vue?vue&type=template&id=1264f7d0&scoped=true&"
import script from "./PuzzleGrid.vue?vue&type=script&lang=js&"
export * from "./PuzzleGrid.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleGrid.vue?vue&type=style&index=0&id=1264f7d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1264f7d0",
  null
  
)

export default component.exports